export default "__VITE_ASSET__Bxkg$YaD__"